import { AddPageWidget } from './AddPageWidget';

export default AddPageWidget;
